import { AgentWeather, AgentSpeedTest, AgentDomainExpert, AgentAiBuilder } from '../utils/Interfaces/AgentTypes';
// import { defaultAgentWeather, defaultAgentSpeedTest, defaultAgentDomainExpert, defaultAgentAiBuilder } from '../utils/Interfaces/AgentDefaults'; // Import the default values
import { StripeCheckout, defaultStripeCheckout, Sensepass, defaultSensepass } from  '../utils/Interfaces/PaymentMethods'; // Import the default values
import { initialAppState } from '../utils/jsonInitialData';
import { JsonBuilderServiceModel, LeadForm } from '../utils/Interfaces/jsonInterface';
type AgentProperty = AgentWeather | AgentSpeedTest | AgentDomainExpert | AgentAiBuilder;
type PaymentMethodProperty = StripeCheckout | Sensepass ;

interface Agent {
  status: string;
  heading: string;
  subHeading: string;
  property: AgentProperty;
}

interface Theme {
  enabled: boolean;
  primaryColor: string;
  backgroundColor: string;
  secondaryColor: string;
}

interface Domain {
  type: string;
  default: string;
  trim: boolean;
}

interface BrandDetail {
  fonts: string[];
  colors: string[];
  logo: string;
  favicon: string;
  title: string;
  description: string;
  topImages: string[];
}



interface Header {
   logo :{
    enabled:boolean,
    alignment:string,
    size:string,
    url:string,
    altText:string,
    link:string
   }
   
}
interface API {
  api:string,
  key:string
}
interface AI {
  model:string,
  key:string
}
interface payments {
  enabled:boolean,
  paymentType:string,
  providers: PaymentMethodProperty[]
}

export class JsonBuilderService {
  // Since we are modifying this property during app creation, we need a different reference. Additionally, we cannot modify a read-only property.
  public data:JsonBuilderServiceModel = JSON.parse(JSON.stringify(initialAppState)); 
  public property: AgentProperty = {} as AgentProperty;
  constructor() {
  }

  // setType(type: 'weather' | 'speedtest' | 'domainexpert' | 'aibuilder') {
  //   this.data.type = type;
  //   switch (type) {
  //     case 'weather':
  //       this.property = defaultAgentWeather;
  //       break;
  //     case 'speedtest':
  //       this.property = defaultAgentSpeedTest;
  //       break;
  //     case 'domainexpert':
  //       this.property = defaultAgentDomainExpert;
  //       break;
  //     case 'aibuilder':
  //       this.property = defaultAgentAiBuilder;
  //       break;
  //     default:
  //       throw new Error('Invalid type');
  //   }
  //   this.data.agent.property = this.property;
  // }

  getData(): JsonBuilderServiceModel {
    return this.data;
  }

  public getField() {
    return JSON.parse(JSON.stringify(this.data.leadForm.fields[0]));
  }
  setData(data: JsonBuilderServiceModel): void { // Ensure type safety here
    this.data = data;
  }

  getAppName(): string {
    return this.data.name;
  }

  setAppName(name: string): void {
    this.data.name = name;
  }

  getStatus(): string {
    return this.data.status;
  }

  setStatus(status: string): void {
    this.data.status = status;
  }

  // getAgent(): Agent {
  //   return this.data.agent;
  // }

  // setAgent(agent: Agent): void {
  //   this.data.agent = agent;
  // }

  getTheme(): Theme {
    return this.data.theme;
  }

  setTheme(theme: Theme): void {
    this.data.theme = theme;
  }

  getDomain(): Domain {
    return this.data.domain;
  }

  setDomain(domain: Domain): void {
    this.data.domain = domain;
  }

  getUseBrandDetail(): boolean {
    return this.data.useBrandDetail;
  }

  setUseBrandDetail(useBrandDetail: boolean): void {
    this.data.useBrandDetail = useBrandDetail;
  }

  getBrandDetail(): BrandDetail {
    return this.data.brandDetail;
  }

  setBrandDetail(brandDetail: BrandDetail): void {
    this.data.brandDetail = brandDetail;
  }

  getLeadForm(): LeadForm {
    return this.data.leadForm;
  }

  setLeadForm(leadForm: LeadForm): void {
    this.data.leadForm = leadForm;
  }

  updateFields(fields: Partial<JsonBuilderServiceModel>) {
    Object.assign(this.data, fields);
  }
}

export type { JsonBuilderServiceModel, Theme, Domain, BrandDetail, LeadForm, Agent };